







import Vue from 'vue'
import Component from "vue-class-component"
import { customer } from "@/store"
import OrderProductsTable from '@/components/orders/OrderProductsTable.vue'
import { deliveryServicesOptions } from '@/utils/constants'

@Component({
  components: {
    OrderProductsTable
  }
})
export default class DeliveryServicesModal extends Vue {
  deliveryServicesOptions = deliveryServicesOptions

  get retailerPage() {
    return customer.retailerPage
  }

  // Геттером, а не копией в mounted(): настройки приезжают запросом, и на
  // первом заходе окно открывалось пустым
  get deliveryServices(): Array<string> {
    return (this.retailerPage && this.retailerPage.deliveryServices) || []
  }

  get filteredDeliveryServicesOptions() {
    return this.deliveryServicesOptions.filter(option => this.deliveryServices.includes(option.value))
  }
}
